import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Login = () => import('@/views/pages/Login')
const ResultImport = () => import('@/views/pages/ResultImport')

Vue.use(Router)

function configRoutes() {
  return [
    {      
      path: '/',
      redirect: '/',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: '/',
          name: '/dashboard',
          component: Dashboard
        },  
        {
          path: '/pages',
          redirect: '/pages/info-pages',
          name: 'Pages',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'login',
              name: 'Login',
              component: Login
            },  
            {
              path: 'result-import',
              name: 'ResultImport',
              component: ResultImport
            },  
          ]
        }   
      ]
    },
  ]
}

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})
